import AppContentContainer from "@/src/app/(auth)/_components/AppContentContainer";
import CompanyForm from "@/src/app/(auth)/profile/edit/_components/CompanyForm";
const EditProfile = () => {
  return (
    <AppContentContainer>
      <CompanyForm />
    </AppContentContainer>
  );
};

export default EditProfile;
